module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/mix-and-match-plan-widget-3ef1e2b7b53acac7ffdb5ff278abdfb4.jpg";